import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const CampusWatersSewers = (props) => {
    const width = props.width ? props.width + 'px' : '35px';
    const height = props.height ? props.height + 'px' : '41px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 35 41"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path d="M35 37.4907H0V41.0055H35V37.4907Z" />
            <path d="M16.3219 23.41H11.0877V15.6265C11.0877 13.5925 12.7437 11.9436 14.7799 11.9436H31.8672V8.42889H23.5V3.51475H28.7343V0H14.7473V3.51475H19.9816V8.43432H14.7799C10.8162 8.43432 7.5855 11.6507 7.56921 15.6103V15.632V23.4154H2.33496V26.9247H16.3219V23.4154V23.41Z" />
            <path d="M3.73572 29.1758H1.93848V33.2763H3.73572V29.1758Z" />
            <path d="M8.00329 29.1758H6.20605V33.2763H8.00329V29.1758Z" />
            <path d="M12.2709 29.1758H10.4736V33.2763H12.2709V29.1758Z" />
            <path d="M16.5443 29.1758H14.7471V33.2763H16.5443V29.1758Z" />
        </SvgStyled>
    );
};

export default CampusWatersSewers;
